"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOSName = getOSName;
exports.getOSVersion = getOSVersion;
var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Module that provides utility functions for operating system detection.
 *
 * @module os
 */

var parser = new _uaParserJs["default"]();
var _parser$getOS = parser.getOS(),
  name = _parser$getOS.name,
  version = _parser$getOS.version;

/**
 * Check whether the Operating System is known
 * @return {string} The current OS name
 */
function getOSName() {
  return name;
}

/**
 * The current OS Version - if included in the UA String
 * @return {string} The current OS name
 */
function getOSVersion() {
  return version;
}